"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  // ifr的父级元素，默认为body
  context: null,
  ifr: null,
  /**
   * [createSchemaIfr 在当前页面中创建iframe，用于调用schema]
   * @param  {Node} doc [用于存放iframe的文档节点，默认为document.body]
   * @return {Node}     [创建的iframe元素]
   */
  createSchemaIfr: function createSchemaIfr(doc, schema) {
    this.context = document.body;
    if (this.ifr) {
      // bugfix: 存在需要重置src，否则连续调用后面的请求没有响应
      this.ifr.src = schema;
      return this.ifr;
    }
    this.ifr = document.createElement('iframe');
    this.context = doc || this.context;
    this.ifr.style.cssText = 'display:none;width:0px;height:0px;';
    this.ifr.src = schema;
    this.ifr = this.context.appendChild(this.ifr);
    return this.ifr;
  },
  /**
   * [destorySchemaIfr 移除ifr元素]
   * @return {[type]} [description]
   */
  destorySchemaIfr: function destorySchemaIfr() {
    if (this.ifr) {
      this.ifr.parentNode.removeChild(this.ifr);
      this.ifr = null;
    }
  },
  /**
   * [loadSchema 在NN内部 调用schema]
   * @param  {String} schema  [schema字符串]
   * @param  {Node}   context [iframe的父级元素默认为document]
   * @param  {Function} callback [调用schema之后的回调函数]
   * @return {[type]}         [description]
   */
  loadSchema: function loadSchema(schema, context, callback) {
    var that = this;
    if (typeof schema !== 'string') {
      throw new Error('the first paramater of loadSchema should be a string');
    }
    this.createSchemaIfr(context, schema);
    setTimeout(function () {
      that.destorySchemaIfr();
    }, 10);
    typeof callback === 'function' && callback();
  }
};
module.exports = exports.default;